import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import your CSS file if you have one

const Players = () => {
  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Players</h1>
        <p>Select a page to visit:</p>
      </header>
      <main className="home-content">
        <nav className="home-nav">
          <ul>
            <li>
              <Link to="/view">View Players</Link>
            </li>
            <li>
              <Link to="/create">Create New Players</Link>
            </li>
            <li>
              <Link to="/Filter2">Filter Players by Name</Link>
            </li>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/">Log-out</Link>
            </li>
          </ul>
        </nav>
      </main>
    </div>
  );
}

export default Players;
